import BN from 'bn.js';

/** USDC scale factor (1e6 = 1 USDC). */
export const D6: number = 1_000_000;
export const D6_BN: BN = new BN(D6);

/** Price and unitless proportion scale factor (1e9). */
export const D9: number = 1_000_000_000;
export const D9_BN: BN = new BN(D9);

/** 100% in basis points. */
export const BPS_DENOMINATOR: number = 10_000;
export const BPS_DENOMINATOR_BN: BN = new BN(BPS_DENOMINATOR);

// NOTE: the three constants below are NOT global contract constants and do
// NOT track the deployed config — the `markets` program stores the real
// values PER-MARKET on `MarketConfig` (`initial_token_supply`,
// `initial_virtual_quote`) and on each `BondingCurve`
// (`virtual_quote_reserves`); read those on-chain values, never these. The
// current devnet bootstrap (bootstrap-admin.ts) uses initial_token_supply =
// 10_000_000_000 (10k outcome tokens, D6) and initial_virtual_quote =
// 10_000_000_000 ($10k, D6) for a $1 starting spot price. The constants here
// are historical curve-scenario inputs kept for the SDK math tests only.

/** Test-scenario supply per outcome (D6 base units). Not the deployed default. */
export const TOTAL_SUPPLY_PER_OUTCOME: number = 1_000_000_000_000;
export const TOTAL_SUPPLY_PER_OUTCOME_BN: BN = new BN(TOTAL_SUPPLY_PER_OUTCOME);

/** Test-scenario virtual USDC reserves (D6). Not the deployed default. */
export const VIRTUAL_USDC_RESERVES: number = 30_000_000_000;
export const VIRTUAL_USDC_RESERVES_BN: BN = new BN(VIRTUAL_USDC_RESERVES);

/** Default virtual token reserves for bonding curve (D6). */
export const VIRTUAL_TOKEN_RESERVES: number = 1_073_000_000_000;
export const VIRTUAL_TOKEN_RESERVES_BN: BN = new BN(VIRTUAL_TOKEN_RESERVES);

/** Minimum reserve threshold to prevent dust (D6). */
export const MIN_RESERVE: number = 1_000;

/** Minimum trade amount ($1 USDC, D6). */
export const MIN_TRADE_AMOUNT: number = 1_000_000;

/** USDC decimal places. */
export const USDC_DECIMALS: number = 6;

/** Outcome token decimal places. */
export const OUTCOME_MINT_DECIMALS: number = 6;

/** Minimum outcomes per market. */
export const MINIMUM_OUTCOMES_PER_MARKET: number = 2;
